"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEval = exports.parseEscape = exports.parseTag = exports.parseList = exports.parseArgs = exports.parseFunction = exports.parseTemplate = exports.parsePattern = void 0;
const random_1 = __importDefault(require("random"));
const errors_1 = require("./errors");
const functionNameRegExp_1 = __importDefault(require("./lib/functionNameRegExp"));
const listStringify_1 = __importDefault(require("./lib/listStringify"));
const registries_1 = require("./registries");
function parsePattern(context, terminator, doNotExecute) {
    let generated = '';
    for (;;) {
        let char = context.get();
        if (char === undefined) {
            if (terminator) {
                errors_1.throwUnexpectedEndOfInput(context, terminator.split('').map(v => `'${v}'`));
            }
            else {
                return generated;
            }
        }
        else if (terminator === null || terminator === void 0 ? void 0 : terminator.includes(char)) {
            return generated;
        }
        else if (char === '%') {
            generated += parseTemplate(context, terminator, doNotExecute);
        }
        else if (char === '\\') {
            generated += parseEscape(context);
        }
        else {
            generated += char;
        }
        context.next();
    }
}
exports.parsePattern = parsePattern;
function parseTemplate(context, terminator, doNotExecute) {
    context.next();
    let char = context.get();
    if (char === undefined) {
        errors_1.throwUnexpectedEndOfInput(context, ['function', 'list', 'tag']);
    }
    else if (terminator === null || terminator === void 0 ? void 0 : terminator.includes(char)) {
        errors_1.throwUnexpectedToken(context, '%');
    }
    else if (char === '{') {
        return parseList(context, doNotExecute);
    }
    else if (char === '[') {
        return parseTag(context, doNotExecute);
    }
    else if (functionNameRegExp_1.default.test(char)) {
        return parseFunction(context, doNotExecute);
    }
    else {
        errors_1.throwUnexpectedToken(context, char);
    }
}
exports.parseTemplate = parseTemplate;
function parseFunction(context, doNotExecute) {
    let funcName = context.get();
    let func = registries_1.functionRegistry.get(funcName);
    if (!doNotExecute && !func) {
        errors_1.throwNotDefinedError(context, funcName);
    }
    let args = [];
    if (context.get(1) === '(') {
        context.next();
        args = parseArgs(context, doNotExecute);
    }
    try {
        return doNotExecute ? '' : func(context, args);
    }
    catch (e) {
        errors_1.throwRuntimeError(context, e);
    }
}
exports.parseFunction = parseFunction;
function parseArgs(context, doNotExecute) {
    let args = [];
    for (;;) {
        let char = context.get();
        if (char === undefined) {
            errors_1.throwUnexpectedEndOfInput(context, [')']);
        }
        else if (char === ')') {
            return args;
        }
        else if (char === '(' || char === ',') {
            context.next();
            args.push(parsePattern(context, ',)', doNotExecute));
        }
    }
}
exports.parseArgs = parseArgs;
function parseList(context, doNotExecute) {
    let items = [];
    for (;;) {
        let char = context.get();
        if (char === undefined) {
            errors_1.throwUnexpectedEndOfInput(context, ['}']);
        }
        else if (char === '}') {
            return listStringify_1.default(items);
        }
        else if (char === '{' || char === ',') {
            context.next();
            items.push(parsePattern(context, ',}', doNotExecute));
        }
    }
}
exports.parseList = parseList;
function parseTag(context, doNotExecute) {
    let tagName = '';
    let isTemplateMode = false;
    let isReference = false;
    let isParsingTagName = true;
    let doNotReturn = false;
    let isInvoke = false;
    context.next();
    if (context.get() === '&') {
        isReference = true;
        context.next();
    }
    else if (context.get() === '@') {
        isReference = true;
        doNotReturn = true;
        context.next();
    }
    if (context.get() === '*') {
        isInvoke = true;
        context.next();
    }
    if (context.get() === '%') {
        isTemplateMode = true;
        context.next();
    }
    for (;; context.next()) {
        let char = context.get();
        if (char === undefined) {
            errors_1.throwUnexpectedEndOfInput(context, [']']);
        }
        else if (char === ':') {
            isParsingTagName = false;
            context.next();
            let startPos = context.index;
            let result = parsePattern(context, ']', doNotExecute || (isTemplateMode && isReference));
            let endPos = context.index;
            if (!doNotExecute) {
                if (isInvoke) {
                    tagName = context.getValueOfVariable(tagName);
                }
                if (isTemplateMode) {
                    tagName = context.setVariable(tagName, context.pattern.slice(startPos, endPos), isTemplateMode);
                }
                else {
                    tagName = context.setVariable(tagName, result, isTemplateMode);
                }
            }
            if (isReference) {
                return doNotReturn ? '' : tagName;
            }
            else {
                return result;
            }
        }
        else if (char === ']') {
            isParsingTagName = false;
            if (!doNotExecute) {
                if (isReference) {
                    return doNotReturn ? '' : tagName;
                }
                else if (isInvoke) {
                    return context.getValueOfVariable(context.getValueOfVariable(tagName));
                }
                else {
                    return context.getValueOfVariable(tagName);
                }
            }
            else {
                return '';
            }
        }
        else if (isParsingTagName) {
            if (/[$\-0-9A-Z_a-z]/.test(char)) {
                tagName += char;
            }
            else {
                errors_1.throwInvalidTagName(context, char);
            }
        }
    }
}
exports.parseTag = parseTag;
function parseEscape(context, doNotExecute) {
    context.next();
    return context.get();
}
exports.parseEscape = parseEscape;
function parseEval(context) {
    let f = {};
    registries_1.functionRegistry.forEach((func, funcName) => {
        f[funcName] = (...args) => func(context, args);
    });
    return (function (context, junze, random) {
        return eval('`' + context.pattern + '`').toString();
    })(context, f, random_1.default);
}
exports.parseEval = parseEval;
